module.exports = __webpack_public_path__ + "assets/img/carrot-attack.e965c551.png";